export enum UserType {
  Administrator = 'Administrator',
  Merchant = 'Merchant',
}

export interface LoginCredentials {
  userName: string;
  password: string;
  userType: UserType;
  twoFaCode?: number;
  emailCode?: string;
}

export interface LoginResponse {
  action: string;
  code: number;
  data: {
    accessToken: string;
    accessSecret: string;
    user?: any;
  };
  message: string;
}

